import Vue from "vue";

const getDefaultState = () => {
  return {
    FormationsDeMasse: [],
    FormationsDeMasseDeRegions: [],

    //field: "name",
    whereField: "users_id_user",
    //whereValue: "superviseur",
    collection: "formations",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.FormationsDeMasse = payload;
  },
  SET_LISTE_FORMATION_DE_MASSE_DE_REGIONS(state, payload) {
    state.FormationsDeMasseDeRegions = payload;
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  ADD_ONE_ITEM(state, payload) {
    state.FormationsDeMasse.push(payload);
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  addOneItem({ commit }, item) {
    commit("ADD_ONE_ITEM", item);
    console.log("added to Vuex formations de masse", item)
  },
  async getFormationsDeMassederegions({ commit }, arrayRegions) {
    commit("RESET_STATE");
    let self = this;
    self._vm.$vloading.show();
    let formationsDeMasse = [];
    this._vm.$firebase
      .firestore()
      .collection("formations")
      .where("id_region", "in", arrayRegions)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          formationsDeMasse.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        commit("SET_LISTE_FORMATION_DE_MASSE_DE_REGIONS", formationsDeMasse);
        self._vm.$vloading.hide();
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  },
  async GetFormationsDeMasseDeSuperviseur({ commit }, objet) {
    // start requête
    var start = this._vm
      .$moment(Date.now())
      .subtract(3, "months")
      .format("YYYY-MM-DD");
    var end = this._vm.$moment(Date.now()).add(3, "days").format("YYYY-MM-DD");
    commit("SET_LISTE", []);
    commit("RESET_STATE");
    commit(
      "Loading/START_BUSY_STATE",
      "FormationsDeMasse GetFormationsDeMasseDeSuperviseur",
      {
        root: true,
      }
    );

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection("formations")
      .where("users_id_user", "==", objet.userId)
      .where("programmes_id_programme", "==", objet.project.id)
      .where("date_formation", ">", start)
      .where("date_formation", "<", end)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            let text = "No Data Available";
            console.log(text);
            //start set snackbar
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = text;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            //End set snackbar
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "FormationsDeMasse.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "FormationsDeMasse.store.js", {
            root: true,
          });
        }
      );
  },
  async GetAll({ commit }) {
    // start requête
    commit("SET_LISTE", []);

    commit("Loading/START_BUSY_STATE", "FormationsDeMasse GetAll", {
      root: true,
    });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.FormationsDeMasse.collection)
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit(
              "Pending/START_PENDING_STATE",
              "Formations de masse GetAll",
              { root: true }
            );
          } else {
            console.log("tout est synchronisé Dans FormationsDeMasse GetAll");
            commit("Pending/END_PENDING_STATE", "Formations de masse GetAll", {
              root: true,
            });
          }

          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            let text = "No Data Available";
            console.log(text);
            //start set snackbar
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = text;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            //End set snackbar
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "FormationsDeMasse.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "FormationsDeMasse.store.js", {
            root: true,
          });
        }
      );
  },
};

const getters = {
  FormationsDeMasse: (state) => {
    return state.FormationsDeMasse;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
